import {
    useWindowWidth,
} from '@react-hook/window-size'

export const useIsXl = () => useWindowWidth() >= 1280;
export const useIsLg = () => useWindowWidth() >= 1024;